import { useEffect } from "react";
import { useApp } from "@/context/AppContext";

const GYG_LOCALES = {
  it: "it-IT", en: "en-US", hr: "hr-HR", sl: "sl-SI",
  de: "de-DE", hu: "hu-HU", cs: "cs-CZ",
};
const SRC = "https://widget.getyourguide.com/dist/pax.js";

/**
 * GetYourGuide affiliate "activities" widget. Requires REACT_APP_GYG_PARTNER_ID.
 * Loads the pax.js script once; the widget div is auto-detected and rendered.
 */
export const GetYourGuideWidget = ({ query = "Umag, Croatia", items = 12 }) => {
  const { lang, t } = useApp();
  const partnerId = process.env.REACT_APP_GYG_PARTNER_ID;

  useEffect(() => {
    if (!partnerId) return;
    let script = document.querySelector(`script[src="${SRC}"]`);
    if (!script) {
      script = document.createElement("script");
      script.src = SRC;
      script.async = true;
      script.defer = true;
      script.setAttribute("data-gyg-partner-id", partnerId);
      document.body.appendChild(script);
    }
    // Nudge pax.js to (re)scan the DOM when navigating within the SPA.
    const id = setTimeout(() => {
      try {
        window.GYG?.container?.refresh?.();
      } catch { /* noop */ }
    }, 600);
    return () => clearTimeout(id);
  }, [partnerId, lang, query]);

  if (!partnerId) {
    return (
      <div
        data-testid="gyg-fallback"
        className="border border-sand-border bg-white p-8 text-center"
      >
        <p className="text-petrol/70">{t("detail.exp_coming_soon")}</p>
        <a
          href={`https://www.getyourguide.com/s/?q=${encodeURIComponent(query)}`}
          target="_blank"
          rel="noreferrer sponsored"
          className="mt-4 inline-flex items-center gap-2 bg-terracotta px-5 py-2.5 font-semibold text-white transition-colors hover:bg-terracotta-hover"
        >
          {t("detail.exp_browse_gyg")}
        </a>
      </div>
    );
  }

  return (
    <div
      data-testid="gyg-widget"
      key={`${lang}-${query}`}
      data-gyg-href="https://widget.getyourguide.com/default/activities.frame"
      data-gyg-locale-code={GYG_LOCALES[lang] || "en-US"}
      data-gyg-widget="activities"
      data-gyg-number-of-items={items}
      data-gyg-partner-id={partnerId}
      data-gyg-q={query}
    />
  );
};
